module.exports = {
  id: 45,
  name: 'Single-Leg Deadlifts',
  categories: ['strength', 'legs', 'balance', 'coordination'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'advanced',
  skill: 'Balance',
  points: 22,
  instructions:
    'Single-leg deadlifts are challenging! Stand on one leg, bend forward, and touch the ground! This builds incredible balance and leg strength!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready for single-leg deadlifts? Let us build incredible balance and strength!',
    },
    {
      time: 3,
      text: 'Stand on your right leg, keep your balance!',
    },
    {
      time: 6,
      text: 'Keep your back straight and core engaged!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Bend forward slowly!',
    },
    // SET 1 - 6 reps right leg
    {
      time: 12,
      text: 'Perfect balance position! Keep your form, standing on your right leg.',
    },
    {
      time: 15,
      text: 'Bend forward slowly, keep your back straight...',
    },
    {
      time: 18,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 21,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 24,
      text: 'Number 2! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 27,
      text: 'Touch the ground with your fingertips, you are doing great!',
    },
    {
      time: 30,
      text: 'Stand back up slowly, stay focused!',
    },
    {
      time: 33,
      text: 'Number 3! Bend forward slowly, keep your back straight!',
    },
    {
      time: 36,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 39,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 42,
      text: 'Number 4! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 45,
      text: 'Touch the ground with your fingertips, you are strong!',
    },
    {
      time: 48,
      text: 'Stand back up slowly, stay focused!',
    },
    {
      time: 51,
      text: 'Number 5! Bend forward slowly, keep your back straight!',
    },
    {
      time: 54,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 57,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 60,
      text: 'Number 6! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 63,
      text: 'Touch the ground with your fingertips, almost there!',
    },
    {
      time: 66,
      text: 'Stand back up slowly, incredible balance!',
    },
    {
      time: 69,
      text: 'Great job! Now switch to your left leg!',
    },
    // REST PERIOD 1 - 30 seconds
    {
      time: 72,
      text: 'Take a deep breath in and out, you are building incredible balance!',
    },
    {
      time: 75,
      text: 'Shake out your legs and get ready for your left leg!',
    },
    {
      time: 78,
      text: 'You are doing amazing! Ready for your left leg? Let us keep going!',
    },
    {
      time: 81,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 1 - 6 reps left leg
    {
      time: 84,
      text: 'Stand on your left leg, keep your balance!',
    },
    {
      time: 87,
      text: 'Keep your back straight and core engaged!',
    },
    {
      time: 90,
      text: 'Perfect balance position! Bend forward slowly!',
    },
    {
      time: 93,
      text: 'Number 1! Bend forward slowly, keep your back straight!',
    },
    {
      time: 96,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 99,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 102,
      text: 'Number 2! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 105,
      text: 'Touch the ground with your fingertips, you are doing great!',
    },
    {
      time: 108,
      text: 'Stand back up slowly, stay focused!',
    },
    {
      time: 111,
      text: 'Number 3! Bend forward slowly, keep your back straight!',
    },
    {
      time: 114,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 117,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 120,
      text: 'Number 4! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 123,
      text: 'Touch the ground with your fingertips, you are strong!',
    },
    {
      time: 126,
      text: 'Stand back up slowly, stay focused!',
    },
    {
      time: 129,
      text: 'Number 5! Bend forward slowly, keep your back straight!',
    },
    {
      time: 132,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 135,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 138,
      text: 'Number 6! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 141,
      text: 'Touch the ground with your fingertips, almost there!',
    },
    {
      time: 144,
      text: 'Stand back up slowly, incredible balance!',
    },
    {
      time: 147,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 2 - 30 seconds
    {
      time: 150,
      text: 'Take a deep breath in and out, you are building incredible balance!',
    },
    {
      time: 153,
      text: 'Shake out your legs and get ready for round two!',
    },
    {
      time: 156,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 159,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 2 - 6 reps right leg
    {
      time: 162,
      text: 'Stand on your right leg, keep your balance!',
    },
    {
      time: 165,
      text: 'Keep your back straight and core engaged!',
    },
    {
      time: 168,
      text: 'Perfect balance position! Bend forward slowly!',
    },
    {
      time: 171,
      text: 'Number 1! Bend forward slowly, keep your back straight!',
    },
    {
      time: 174,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 177,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 180,
      text: 'Number 2! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 183,
      text: 'Touch the ground with your fingertips, you are doing great!',
    },
    {
      time: 186,
      text: 'Stand back up slowly, stay focused!',
    },
    {
      time: 189,
      text: 'Number 3! Bend forward slowly, keep your back straight!',
    },
    {
      time: 192,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 195,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 198,
      text: 'Number 4! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 201,
      text: 'Touch the ground with your fingertips, you are strong!',
    },
    {
      time: 204,
      text: 'Stand back up slowly, stay focused!',
    },
    {
      time: 207,
      text: 'Number 5! Bend forward slowly, keep your back straight!',
    },
    {
      time: 210,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 213,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 216,
      text: 'Number 6! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 219,
      text: 'Touch the ground with your fingertips, almost there!',
    },
    {
      time: 222,
      text: 'Stand back up slowly, incredible balance!',
    },
    {
      time: 225,
      text: 'Great job! Now switch to your left leg!',
    },
    // REST PERIOD 3 - 30 seconds
    {
      time: 228,
      text: 'Take a deep breath in and out, you are building incredible balance!',
    },
    {
      time: 231,
      text: 'Shake out your legs and get ready for your left leg!',
    },
    {
      time: 234,
      text: 'You are doing amazing! Ready for your left leg? Let us keep going!',
    },
    {
      time: 237,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 2 - 6 reps left leg
    {
      time: 240,
      text: 'Stand on your left leg, keep your balance!',
    },
    {
      time: 243,
      text: 'Keep your back straight and core engaged!',
    },
    {
      time: 246,
      text: 'Perfect balance position! Bend forward slowly!',
    },
    {
      time: 249,
      text: 'Number 1! Bend forward slowly, keep your back straight!',
    },
    {
      time: 252,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 255,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 258,
      text: 'Number 2! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 261,
      text: 'Touch the ground with your fingertips, you are doing great!',
    },
    {
      time: 264,
      text: 'Stand back up slowly, stay focused!',
    },
    {
      time: 267,
      text: 'Number 3! Bend forward slowly, keep your back straight!',
    },
    {
      time: 270,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 273,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 276,
      text: 'Number 4! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 279,
      text: 'Touch the ground with your fingertips, you are strong!',
    },
    {
      time: 282,
      text: 'Stand back up slowly, stay focused!',
    },
    {
      time: 285,
      text: 'Number 5! Bend forward slowly, keep your back straight!',
    },
    {
      time: 288,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 291,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 294,
      text: 'Number 6! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 297,
      text: 'Touch the ground with your fingertips, almost there!',
    },
    {
      time: 300,
      text: 'Stand back up slowly, incredible balance!',
    },
    {
      time: 303,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 4 - 30 seconds
    {
      time: 306,
      text: 'Take a deep breath in and out, you are building incredible balance!',
    },
    {
      time: 309,
      text: 'Shake out your legs and get ready for the final round!',
    },
    {
      time: 312,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 315,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 3 - 6 reps right leg
    {
      time: 318,
      text: 'Stand on your right leg, keep your balance!',
    },
    {
      time: 321,
      text: 'Keep your back straight and core engaged!',
    },
    {
      time: 324,
      text: 'Perfect balance position! Bend forward slowly!',
    },
    {
      time: 327,
      text: 'Number 1! Bend forward slowly, keep your back straight!',
    },
    {
      time: 330,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 333,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 336,
      text: 'Number 2! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 339,
      text: 'Touch the ground with your fingertips, you are doing great!',
    },
    {
      time: 342,
      text: 'Stand back up slowly, stay focused!',
    },
    {
      time: 345,
      text: 'Number 3! Bend forward slowly, keep your back straight!',
    },
    {
      time: 348,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 351,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 354,
      text: 'Number 4! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 357,
      text: 'Touch the ground with your fingertips, you are strong!',
    },
    {
      time: 360,
      text: 'Stand back up slowly, stay focused!',
    },
    {
      time: 363,
      text: 'Number 5! Bend forward slowly, keep your back straight!',
    },
    {
      time: 366,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 369,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 372,
      text: 'Number 6! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 375,
      text: 'Touch the ground with your fingertips, almost there!',
    },
    {
      time: 378,
      text: 'Stand back up slowly, incredible balance!',
    },
    {
      time: 381,
      text: 'Great job! Now switch to your left leg!',
    },
    // REST PERIOD 5 - 30 seconds
    {
      time: 384,
      text: 'Take a deep breath in and out, you are building incredible balance!',
    },
    {
      time: 387,
      text: 'Shake out your legs and get ready for your left leg!',
    },
    {
      time: 390,
      text: 'You are doing amazing! Ready for your left leg? Let us finish strong!',
    },
    {
      time: 393,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 3 - 6 reps left leg
    {
      time: 396,
      text: 'Stand on your left leg, keep your balance!',
    },
    {
      time: 399,
      text: 'Keep your back straight and core engaged!',
    },
    {
      time: 402,
      text: 'Perfect balance position! Bend forward slowly!',
    },
    {
      time: 405,
      text: 'Number 1! Bend forward slowly, keep your back straight!',
    },
    {
      time: 408,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 411,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 414,
      text: 'Number 2! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 417,
      text: 'Touch the ground with your fingertips, you are doing great!',
    },
    {
      time: 420,
      text: 'Stand back up slowly, stay focused!',
    },
    {
      time: 423,
      text: 'Number 3! Bend forward slowly, keep your back straight!',
    },
    {
      time: 426,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 429,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 432,
      text: 'Number 4! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 435,
      text: 'Touch the ground with your fingertips, you are strong!',
    },
    {
      time: 438,
      text: 'Stand back up slowly, stay focused!',
    },
    {
      time: 441,
      text: 'Number 5! Bend forward slowly, keep your back straight!',
    },
    {
      time: 444,
      text: 'Touch the ground with your fingertips, feel the stretch!',
    },
    {
      time: 447,
      text: 'Stand back up slowly, keep your balance!',
    },
    {
      time: 450,
      text: 'Number 6! Bend forward slowly, keep your core engaged!',
    },
    {
      time: 453,
      text: 'Touch the ground with your fingertips, almost there!',
    },
    {
      time: 456,
      text: 'Stand back up slowly, incredible balance!',
    },
    {
      time: 459,
      text: 'Incredible work! You are done! You just completed all three sets!',
    },
    // COMPLETION
    {
      time: 462,
      text: 'Amazing work! You did 36 single-leg deadlifts and built incredible balance!',
    },
    {
      time: 465,
      text: 'Your balance and leg strength are getting super strong! You are a balance master!',
    },
    {
      time: 468,
      text: 'Great job, balance champion! You are building incredible skills!',
    },
  ],
};
